import script from "./FilePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePicker.vue?vue&type=script&setup=true&lang=ts"

import "./FilePicker.vue?vue&type=style&index=0&id=4d892942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d892942"]])

export default __exports__